import { ofType } from 'redux-observable';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';
import config from 'config.json';
import { fetchAvailableEmployees } from '../searchEmployees'
import { dispatch } from 'rxjs/internal/observable/pairs';

//const CALENDAR_EVENTS_FIELDS = 'id,description, datasheet(id,name,customer(id,name),office(id,name),address(city,line1,line2,state,zip)),customer(name,phone,address(city,line1,line2,state,zip)) ,startTime,endTime)';
const CALENDAR_EVENTS_FIELDS_DATASHEET = 'id,name,address(city,line1,line2,state,zip),officename,office(id,name,color), customer(id,name,phonenumber,address(city,line1,line2,state,zip),assignedto(id,calendarColor,firstName,lastName)),assignedtoresource(id,calendarColor,firstName,lastName)';
const CALENDAR_EVENTS_FIELDS_CUSTOMER = 'id,name,phonenumber,address(city,line1,line2,state,zip),office(id,name,color),assignedto(id,calendarColor,firstName,lastName)';


// Action types
const FETCH_AVAILABLE_APPOINTMENT = 'FETCH_AVAILABLE_APPOINTMENT';
const FETCH_AVAILABLE_APPOINTMENT_COMPLETE = 'FETCH_AVAILABLE_APPOINTMENT_COMPLETE';
const SEARCH_CUSTOMERS = 'FETCH_CUSTOMERS';
const SEARCH_CUSTOMERS_COMPLETE = 'FETCH_CUSTOMERS_COMPLETE';
const SEARCH_DATASHEETS = "SEARCH_DATASHEETS";
const SEARCH_DATASHEETS_COMPLETE = "SEARCH_DATASHEETS_COMPLETE"
const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA';
const SET_APPOINTMENT_TOGGLE = 'SET_APPOINTMENT_TOGGLE';
const SEARCH_TOGGLE = 'SEARCH_TOGGLE';




const DEFAULT_STATE = {
  form: {
    customers: [],        
    offices: [],
    salespeople: [],
    datasheetsearch:true,
  },
  datasheetsearch:localStorage.getItem('datasheetsearch') !=='true',
  customers: {
    customers: [],
    loading: false
  },  
  datasheets: {
    datasheets: [],
    loading: false
  },  
  appointments:[],  
  loading: false,
  appointmentToggle:{
    togleState: false,
    toggleClass:'fa fa-chevron-left'
   },
};

// Reducer
export default function searchAppointments (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_AVAILABLE_APPOINTMENT:
      
      return {
        ...state,
        appointments: [],
        loading: true
      };
    case FETCH_AVAILABLE_APPOINTMENT_COMPLETE:
      
      return {
        ...state,
        ...payload,
        loading: false
      };
    case SEARCH_CUSTOMERS:
      return {
        ...state,
        customers: {
          customers: [],
          loading: true
        }
      };
    case SEARCH_CUSTOMERS_COMPLETE:
      return {
        ...state,
        customers: {
          customers: payload.customers,
          loading: false
        }
      };
      case SEARCH_DATASHEETS:
        return {
          ...state,
          datasheets: {
            datasheets: [],
            loading: true
          }
        };
        case SEARCH_DATASHEETS_COMPLETE:
        if(!payload)
        payload =  [];  

          return {
            ...state,
            datasheets: {
              datasheets: payload.datasheets,
              loading: false
            }
          };
    case UPDATE_SEARCH_CRITERIA:
      return {
        ...state,
        form: {
          ...state.form,
          ...payload
        },
        loading: true
      };
      case SET_APPOINTMENT_TOGGLE:
        return {
          ...state,
          appointmentToggle:payload          
        };
        case SEARCH_TOGGLE:
          
        try { localStorage.setItem("datasheetsearch", state.datasheetsearch); } catch (e) { }
        
      return {
        ...state,
        datasheetsearch: !state.datasheetsearch,
        form:{
          ...state.form,
          datasheetsearch: !state.datasheetsearch
        }
      };
      
    default:
      return state;
  }
}

// Action creators
export const fetchAvailableAppointments = () => ({
  type: FETCH_AVAILABLE_APPOINTMENT
});

const fetchAvailableAppointmentsComplete = (appointments) => ({
  type: FETCH_AVAILABLE_APPOINTMENT_COMPLETE,
  payload: { appointments }
});

export const searchCustomers = (query) => ({
  type: SEARCH_CUSTOMERS,
  payload: { query }
});

export const searchDatasheets = (query) => ({
  type: SEARCH_DATASHEETS,
  payload: { query }
});

const searchCustomersComplete = (customers) => ({
  type: SEARCH_CUSTOMERS_COMPLETE,
  payload: { customers }
});

const searchDatasheetsComplete = (datasheets) => ({
  type: SEARCH_DATASHEETS_COMPLETE,
  payload: { datasheets }
});

export const openDatasheet = (datahseetId) => {
  window.open(`${config.versaItRoot}display.asp?key=6075&fo=basic%20display&rm=page&xID=${datahseetId}`);
};
export const openCustomer = (customerId) => {
  window.open(`${config.versaItRoot}display.asp?key=6073&fo=basic%20display&rm=page&xID=${customerId}`);
};


export const updateSearchCriteria = (criteria) => {
  return (dispatch) => {
    dispatch({type: UPDATE_SEARCH_CRITERIA, payload: criteria})
    dispatch(fetchAvailableEmployees());
  }
};

/*
export const updateSettings = (values) => {
  
  return (dispatch) => {    
    dispatch({type: UPDATE_SETTINGS, payload: values})
    dispatch(fetchAvailableEmployees());
  }    
  
};
*/

export const setAppointmentToggle = (toggle) => ({
  type: SET_APPOINTMENT_TOGGLE,
  payload:  toggle 
});

export const toggleDatasheetsearch = () => ({
  type: SEARCH_TOGGLE,
});

// Epics

export const fetchAvailableAppointmentsEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_AVAILABLE_APPOINTMENT, UPDATE_SEARCH_CRITERIA,SEARCH_TOGGLE),
  debounceTime(300),
  switchMap(() => {
    //console.log(state$.value);
    var appointments={
      datasheets:[],
      customers:[]
    };
    

    const { customerId, offices, query, customerquery, salespeople,datasheetsearch } = state$.value.searchAppointments.form;
    
    // Build API filter criteria
    const criteria = {
      processComplete: false
    };
         
    if (offices.length) {
      criteria.office = offices.map((o) => o.name);
    }

    
    if (salespeople.length) {
      criteria.salespersonId = salespeople.map(s => s.id);
    }    
    
    if(query && customerquery)
    {
      criteria.customerName = customerquery;
      criteria.query = query;

      return JobProApi.datasheets.search(criteria, {
        fields: CALENDAR_EVENTS_FIELDS_DATASHEET,
        limit: 50
      });

    }
    else if(query && !customerquery)
    {
      criteria.query = query;
      return JobProApi.datasheets.search(criteria, {
        fields: CALENDAR_EVENTS_FIELDS_DATASHEET,
        limit: 50
      });
    }
    else if(customerquery)
    {
      criteria.name = customerquery;
      
      return JobProApi.customers.search(criteria, {
        fields: CALENDAR_EVENTS_FIELDS_CUSTOMER,
        limit: 50
      });
     
    } 
    else
    {
      return JobProApi.datasheets.search(criteria, {
        fields: CALENDAR_EVENTS_FIELDS_DATASHEET,
        limit: 50
      });
    
    }         
    
  }),
  map(fetchAvailableAppointmentsComplete),
);

export const searchCustomersEpic = (action$) => action$.pipe(
  ofType(SEARCH_CUSTOMERS),
  debounceTime(300),
  switchMap(({ payload }) => {
    const { query } = payload;
    return JobProApi.customers.search({
      query
    }, {
        fields: 'id,name,phonenumber,address(city,line1,line2,state,zip),salesperson(id,calendarColor,firstName,lastName)'
      });
  }),
  map(searchCustomersComplete),
);

export const searchDatasheetsEpic = (action$) => action$.pipe(
  ofType(SEARCH_DATASHEETS),
  debounceTime(300),
  switchMap(({ payload }) => {
    const { query } = payload;
    return JobProApi.datasheets.search({
      query
    }, {
        fields: 'id,name'
      });
  }),
  map(searchDatasheetsComplete),
);